import { useState } from "react";
import {
  TextMessages,
} from "V2.0/HomePages/Threads/components/conversation_messages";
import { getConversationById } from "V2.0/services/conversationService";

export default Conversation;

export function useConversation() {
  const [conversation, setConversation] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchConversation = async (projectId, conversationId) => {
    setLoading(true);

    try {
      const response = await getConversationById({ projectId, conversationId });

      setConversation(response.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return {
    conversation,
    loading,
    fetchConversation,
  };
}

function Conversation(props) {
  const { conversation } = props;

  return <TextMessages messages={conversation.messages} />;
}
